import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { getJwt } from "@velocity-ehs/user-utils-module";

class BaseService {
  public api: AxiosInstance;

  constructor(baseURL: string, includeApolloHeader: boolean = false) {
    const headers = { "Content-Type": "application/json;charset=UTF-8" };
    if (includeApolloHeader) {
      headers["apollographql-client-name"] = "accelerate-frontend";
    }
    this.api = axios.create({
      baseURL,
      headers: headers,
    });

    this.addBearerTokenInterceptor();
    this.addGraphQLErrorInterceptor();
  }

  protected addBearerTokenInterceptor() {
    this.api.interceptors.request.use((config) => {
      //@ts-ignore
      config.headers["Authorization"] = "Bearer " + getJwt();
      return config;
    });
  }

  protected addGraphQLErrorInterceptor() {
    this.api.interceptors.response.use(
      (response: AxiosResponse) => {
        let errors = response?.data?.errors;
        if (errors) {
          // eslint-disable-next-line
          throw { response };
        } else {
          return response;
        }
      },
      (error: AxiosError) => {
        throw error;
      }
    );
  }
}

export default BaseService;
